export default "__VITE_ASSET__98688310__"